// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { CreateOpenEdgeCardReaderRequest } from './create-open-edge-card-reader-request';

/** See com.rev360.pms.api.controller.admin.solutions.openedge.UpdateOpenEdgeCardReaderRequest */
/* istanbul ignore next */
@GandalfModel
export class UpdateOpenEdgeCardReaderRequest extends CreateOpenEdgeCardReaderRequest {

	@GandalfLabel('Host name')
	@GandalfValidator({ notNull: { message: 'Host name is required' } })
	@GandalfValidator({ sizeString: { message: 'Host name must be between 1 and 100 characters', minLength: 1, maxLength: 100 } })
	@GandalfProperty({ designType: String, isRequired: true })
	hostName!: string;

	@GandalfLabel('Deleted')
	@GandalfValidator({ notNull: { message: 'Deleted is required' } })
	@GandalfProperty({ designType: Boolean, isRequired: true })
	isDeleted!: boolean;

	@GandalfLabel('Name')
	@GandalfValidator({ notNull: { message: 'Name is required' } })
	@GandalfValidator({ sizeString: { message: 'Name must be between 1 and 100 characters', minLength: 1, maxLength: 100 } })
	@GandalfProperty({ designType: String, isRequired: true })
	name!: string;

	@GandalfLabel('Card reader')
	@GandalfValidator({ notNull: { message: 'Card reader is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	openEdgeCardReaderId!: number;

}
